import { Trans } from 'react-i18next';
import { generateSimpleList } from '../../utils/common';
import MainBlockLayout from '../../components/MainBlockLayout';

// Graduation exams taken at the end of Year 10
const EXAM_LIST = ['Ukrainian language', 'Ukrainian literature', 'History of Ukraine'];

// Sub page of School curriculum: /school-info/school-curriculum/examinations
function MainBlock() {
  return (
    <>
      <p><Trans i18nKey="During their school life" /></p>
      <ul>
        {generateSimpleList(EXAM_LIST)}
      </ul>
      <p><Trans i18nKey="two research papers" /></p>
    </>
  );
}

export default MainBlockLayout(MainBlock);
